/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Paper, Stack, TextField, Button, InputAdornment, IconButton, Box, Popper, Collapse, useMediaQuery, ButtonGroup, FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, Typography, DialogContent, DialogActions, Backdrop, CircularProgress } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useState, ChangeEvent, useRef, } from "react";

import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import { ArrowDropDown, ArrowDropUp, Close, DriveFileMove, Edit, Forward, Inventory, NoteAdd, Print, Search, Undo } from '@mui/icons-material';
import DateRangePopper from '../../../common/components/DateRangePopper';
import { textBoxInputForSmallButtons } from '../../../common/CustumEmotionStyles';
import { GridSelectionModel, GridToolbarColumnsButton, GridToolbarExport } from '@mui/x-data-grid';
import { NumericFormatWhole } from '../../../common/CustomFunctions';
import { digiAccGuiStates } from '../../../common/TextTypes';
import SourceDocumentBusinessLogic from '../../../businessLogic/SourceDocumentBusinessLogic';


interface IProps {
    disableCreate: boolean,
    handleClearAndUpdateDatagrid: () => void,
    handlePrint: () => void,
    handleNewDocument: () => void,
    handleCorrect: () => void,
    searchSimple: string,
    handleSearchSimple: (text: string) => void,
    openAdvancedSearch: boolean,
    handleOpenAdvnacedSearchToggle: () => void,
    status: digiAccGuiStates,
    handleUpdateStatus: (status: digiAccGuiStates) => void,
    invoiceNo: string,
    handleInvoiceNo: (invoiceNo: string) => void,
    voucherDateFrom: Date | undefined,
    handleVoucherDateFrom: (date: Date | undefined) => void,
    voucherDateTo: Date | undefined,
    handleVoucherDateTo: (date: Date | undefined) => void,
    dueDateFrom: Date | undefined,
    handleDueDateFrom: (date: Date | undefined) => void,
    dueDateTo: Date | undefined,
    handleDueDateTo: (date: Date | undefined) => void,
    amountFrom: string,
    handleAmountFrom: (amount: string) => void,
    amountTo: string,
    handleAmountTo: (amount: string) => void,
    voucherNoFrom: string,
    handleVoucherNoFrom: (voucherNo: string) => void,
    voucherNoTo: string,
    handleVoucherNoTo: (voucherNo: string) => void,
    debet: string,
    handleDebet: (status: string) => void,
    credit: string,
    handleCredit: (status: string) => void,
    department: string,
    handleDepartment: (status: string) => void,
    project: string,
    handleProject: (status: string) => void,
    valueDateFrom: Date | undefined,
    handleValueDateFrom: (date: Date | undefined) => void,
    valueDateTo: Date | undefined,
    handleValueDateTo: (date: Date | undefined) => void,
    createdDateFrom: Date | undefined,
    handleCreatedDateFrom: (date: Date | undefined) => void,
    createdDateTo: Date | undefined,
    handleCreatedDateTo: (date: Date | undefined) => void,
    comment: string,
    handleComment: (status: string) => void,
    voucherRegistrationSelection: GridSelectionModel,
    site: "IncomingInvoice" | "OutgoingInvoice" | "Banking" | "JournalEntries" | "Miscellaneous" | "Addition" | "Cash" | "Statement",
}

const DatagridVoucherRegistrationToolbar = (props: IProps): JSX.Element => {

    const theme = useTheme();

    const { t, i18n } = useTranslation();

    const { organizationId } = useParams();

    const [loader, setLoader] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);
    const [dialogType, setDialogType] = useState<"transfer" | "transferAll" | "undoReject" | "move" | "correct" | null>(null)
    const [moveType, setMoveType] = useState<"IncomingInvoice" | "OutgoingInvoice" | "Banking" | "JournalEntries" | "Miscellaneous" | "Addition" | "Cash" | "Statement">("IncomingInvoice");

    const handleOpenDialog = (type: "transfer" | "transferAll" | "undoReject" | "move" | "correct" | null) => {
        if (type) {
            setDialogType(type);
            setOpenDialog(true);
        }
    }
    const handleCloseDialog = () => {
        setDialogType(null);
        setOpenDialog(false);
    }

    const [openTransferButtonArrow, setOpenTranferButtonArrow] = useState(false);
    const anchorTranferButtonArrowRef = useRef<HTMLDivElement>(null);

    const handleTranferButtonArrowToggle = () => {
        setOpenTranferButtonArrow((prevOpen) => !prevOpen);
    }

    const handleDialogAction = async () => {

        if (organizationId) {

            const logic = new SourceDocumentBusinessLogic();

            if (dialogType === "transfer") {
                setLoader(true);
                const result = await logic.postSourceDocumentTransfer(organizationId, voucherRegistrationSelection.map(e => parseInt(e.toString())));
                setLoader(false);
                if (result.hasErrors) {
                    toast(t("voucherRegistration.errorTransfer"))
                } else {
                    handleClearAndUpdateDatagrid();
                    handleCloseDialog();
                }
            } else if (dialogType === "transferAll") {
                setLoader(true);
                const result = await logic.postSourceDocumentTransferAll(organizationId, site);
                setLoader(false);
                if (result.hasErrors) {
                    toast(t("voucherRegistration.errorTransfer"))
                } else {
                    handleClearAndUpdateDatagrid();
                    handleCloseDialog();
                }
            } else if (dialogType === "undoReject") {
                setLoader(true);
                const result = await logic.postSourceDocumentUndoReject(organizationId, voucherRegistrationSelection.map(e => parseInt(e.toString())));
                setLoader(false);
                if (result.hasErrors) {
                    toast(t("voucherRegistration.errorUndoReject"))
                } else {
                    handleClearAndUpdateDatagrid();
                    handleCloseDialog();
                }
            } else if (dialogType === "move") {
                setLoader(true);
                const result = await logic.postSourceDocumentMove(organizationId, voucherRegistrationSelection.map(e => parseInt(e.toString())), moveType);
                setLoader(false);
                if (result.hasErrors) {
                    toast(t("voucherRegistration.errorMove"))
                } else {
                    handleClearAndUpdateDatagrid();
                    handleCloseDialog();
                }
            } else if (dialogType === "correct") {
                setLoader(true);
                const result = await logic.postSourceDocumentCreateAddition(organizationId, voucherRegistrationSelection.map(e => parseInt(e.toString())));
                setLoader(false);
                if (result.hasErrors) {
                    toast(t("voucherRegistration.errorCorrect"))
                } else {
                    handleClearAndUpdateDatagrid();
                    handleCloseDialog();
                }
            }

            
        } else {
            toast(t("basic.errorWithOrganization"));
        }
    }

    function amountError(value: string) {
        if (value !== "" && /^\d+(,\d+)?$/.test(value) === false) {
            return true;
        } else {
            return false;
        }
    }
    const isMobile = useMediaQuery(theme.breakpoints.down('md')) //Check if user is on mobile

    const {
        disableCreate,
        handlePrint,
        handleNewDocument,
        handleClearAndUpdateDatagrid,
        handleCorrect,
        searchSimple,
        handleSearchSimple,
        openAdvancedSearch,
        handleOpenAdvnacedSearchToggle,
        status,
        handleUpdateStatus,
        invoiceNo,
        handleInvoiceNo,
        voucherDateFrom,
        handleVoucherDateFrom,
        voucherDateTo,
        handleVoucherDateTo,
        dueDateFrom,
        handleDueDateFrom,
        dueDateTo,
        handleDueDateTo,
        amountFrom,
        handleAmountFrom,
        amountTo,
        handleAmountTo,
        voucherNoFrom,
        handleVoucherNoFrom,
        voucherNoTo,
        handleVoucherNoTo,
        debet,
        handleDebet,
        credit,
        handleCredit,
        department,
        handleDepartment,
        project,
        handleProject,
        valueDateFrom,
        handleValueDateFrom,
        valueDateTo,
        handleValueDateTo,
        createdDateFrom,
        handleCreatedDateFrom,
        createdDateTo,
        handleCreatedDateTo,
        comment,
        handleComment,
        voucherRegistrationSelection,
        site,

    } = props;

    return <Box >
        <Grid container spacing={theme.spacing(1)} justifyContent="space-between">
            <Grid>
                <Stack spacing={theme.spacing(1)} direction="row">
                    <Button disabled={voucherRegistrationSelection.length > 0 ? false : true} onClick={handlePrint} variant="contained"><Print /></Button>
                    <Button disabled={disableCreate} sx={{ display: disableCreate ? "none" : "inherit" }} onClick={handleNewDocument} variant="contained" startIcon={<NoteAdd />} color="success">
                        {t("basic.create")}
                    </Button>
                    <ButtonGroup color="secondary" variant="contained" ref={anchorTranferButtonArrowRef}>
                        <Button disabled={voucherRegistrationSelection.length > 0 ? false : true} onClick={() => handleOpenDialog("transfer")} startIcon={<DriveFileMove />}>
                            {t("voucherRegistration.transfer")}
                        </Button>
                        <Button size="small" onClick={handleTranferButtonArrowToggle}>
                            <ArrowDropDown />
                        </Button>
                    </ButtonGroup>
                    <Popper
                        open={openTransferButtonArrow}
                        anchorEl={anchorTranferButtonArrowRef.current}>
                        <Paper>
                            <Button onClick={() => handleOpenDialog("transferAll")} variant="outlined" endIcon={<Inventory />}>{t("voucherRegistration.transferAll")}</Button>
                        </Paper>
                    </Popper>
                    <Button disabled={voucherRegistrationSelection.length > 0 ? false : true} onClick={() => handleOpenDialog("undoReject")} variant="contained" startIcon={<Undo />} color="error">
                        {t("voucherRegistration.undoReject")}
                    </Button>
                    <Button disabled={voucherRegistrationSelection.length > 0 ? false : true} onClick={() => handleOpenDialog("move")} variant="contained" startIcon={<Forward />} color="info">
                        {t("voucherRegistration.move")}
                    </Button>
                    <Button disabled={voucherRegistrationSelection.length > 0 ? false : true} onClick={() => handleOpenDialog("correct")} variant="contained" startIcon={<Edit />} color="warning">
                        {t("voucherRegistration.correct")}
                    </Button>
                </Stack>
            </Grid>
            <Grid>
                <Stack spacing={theme.spacing(1)} direction="row">
                    <TextField
                        css={textBoxInputForSmallButtons(theme)}
                        size="small"
                        variant="outlined"
                        label={t("search.search")}
                        color="warning"
                        value={searchSimple}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handleSearchSimple(e.target.value)} />
                    <Button size="small" variant="outlined"><GridToolbarColumnsButton placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} /></Button>
                    <Button size="small" variant="outlined"><GridToolbarExport /></Button>
                    <Button
                        startIcon={<Search />}
                        endIcon={openAdvancedSearch ? <ArrowDropUp /> : <ArrowDropDown />}
                        variant="outlined"
                        onClick={handleOpenAdvnacedSearchToggle}>
                        {t("search.advancedSearch")}
                    </Button>
                </Stack>
            </Grid>
        </Grid>
        {dialogType && <Dialog
            maxWidth="xs"
            fullWidth
            onClose={(event, reason) => handleCloseDialog()}
            open={openDialog}
        >
            <DialogTitle>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid>
                        <Typography variant="h6">{
                            dialogType === "transfer" || dialogType === "transferAll" ? t("voucherRegistration.transferDocuments") :
                                dialogType === "undoReject" ? t("voucherRegistration.undoRejectDocuments") :
                                    dialogType === "move" ? t("voucherRegistration.moveDocuments") : t("voucherRegistration.correctDocuments")
                        }</Typography>
                    </Grid>
                    <Grid>
                        <Button variant="text" onClick={() => handleCloseDialog()}>{t("basic.close")}</Button>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Stack direction="column" spacing={5}>
                    <Typography variant="h5">{voucherRegistrationSelection.length + " " + t("basic.documents")}</Typography>
                    <FormControl color="warning" size="small" sx={{ minWidth: "11rem", maxWidth: "16rem", display: dialogType === "move" ? "inline-flex" : "none" }}>
                        <InputLabel id="select-doc">{t("voucherRegistration.moveTo")}</InputLabel>
                        <Select color="warning"
                            labelId="select-doc-label"
                            id="select-doc"
                            value={moveType}
                            label={t("voucherRegistration.moveTo")}
                            onChange={(e) => setMoveType(e.target.value as ("IncomingInvoice" | "OutgoingInvoice" | "Banking" | "JournalEntries" | "Miscellaneous" | "Addition" | "Cash" | "Statement"))}
                        >
                            <MenuItem value={"IncomingInvoice"}>{t("types.incomingInvoice")}</MenuItem>
                            <MenuItem value={"OutgoingInvoice"}>{t("types.outgoingInvoice")}</MenuItem>
                            <MenuItem value={"Banking"}>{t("types.banking")}</MenuItem>
                            <MenuItem value={"JournalEntries"}>{t("types.journalEntries")}</MenuItem>
                            <MenuItem value={"Miscellaneous"}>{t("types.miscellaneous")}</MenuItem>
                            <MenuItem value={"Addition"}>{t("types.addition")}</MenuItem>
                            <MenuItem value={"Cash"}>{t("types.cash")}</MenuItem>
                            <MenuItem value={"Statement"}>{t("types.statement")}</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleDialogAction}>{
                    dialogType === "transfer" || dialogType === "transferAll" ? t("voucherRegistration.transfer") :
                        dialogType === "undoReject" ? t("voucherRegistration.undoReject") : dialogType === "move" ? t("voucherRegistration.move") : t("voucherRegistration.correct")
                }</Button>
            </DialogActions>
        </Dialog>}
        <Collapse in={openAdvancedSearch} timeout="auto" unmountOnExit orientation="vertical">
            <Grid container spacing={theme.spacing(2)} sx={{ bgcolor: theme.palette.background.default, marginTop: theme.spacing(4), paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2) }}>

                <Grid>
                    <Stack direction="column" spacing={theme.spacing(3)}>
                        <Box sx={{ minWidth: "12rem", backgroundColor: theme.palette.background.paper, }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="select-status">{t('search.status')}</InputLabel>
                                <Select
                                    labelId="select-status-label"
                                    id="select-status"
                                    value={status}
                                    label={t('search.status')}
                                    onChange={e => handleUpdateStatus(e.target.value as digiAccGuiStates)}
                                >
                                    <MenuItem value={"All"}>{t("status.all")}</MenuItem>
                                    <MenuItem value={"Transferred"}>{t("status.transferred")}</MenuItem>
                                    <MenuItem value={"AdditionTransferred"}>{t("status.additionTransferred")}</MenuItem>
                                    {/*<MenuItem value={"ApprovalPending"}>{t("status.approvalPending")}</MenuItem>*/}
                                    {/*<MenuItem value={"ApprovalPostponed"}>{t("status.approvalPostponed")}</MenuItem>*/}
                                    <MenuItem value={"AwaitingForDataEntry"}>{t("status.awaitingForDataEntry")}</MenuItem>
                                    <MenuItem value={"AwaitingForTransfer"}>{t("status.awaitingForTransfer")}</MenuItem>
                                    <MenuItem value={"InProgress"}>{t("status.inProgress")}</MenuItem>
                                    <MenuItem value={"Rejected"}>{t("status.rejected")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <TextField size="small" variant="outlined" color="warning"
                            sx={{ width: "12rem", backgroundColor: theme.palette.background.paper, }}
                            value={invoiceNo}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputComponent: NumericFormatWhole as any,
                                endAdornment:
                                    <InputAdornment position="end" component={IconButton} onClick={() => handleInvoiceNo("")}
                                        sx={{ display: invoiceNo ? "inherit" : "none" }}><Close /></InputAdornment>,
                            }}
                            onChange={(e) => handleInvoiceNo(e.target.value)}
                            id="searchInvoiceNr" label={t('search.invoiceId')} />
                    </Stack>
                </Grid>
                <Grid>
                    <Stack direction="column" spacing={theme.spacing(3)}>
                        <DateRangePopper
                            whiteBackground={true}
                            fromDate={voucherDateFrom} handleFromDate={handleVoucherDateFrom}
                            toDate={voucherDateTo} handleToDate={handleVoucherDateTo}
                            dateName={t('search.voucherDate')} mobile={isMobile} />
                        <DateRangePopper
                            whiteBackground={true}
                            fromDate={dueDateFrom} handleFromDate={handleDueDateFrom}
                            toDate={dueDateTo} handleToDate={handleDueDateTo}
                            dateName={t('search.dueDate')} mobile={isMobile} />
                        <DateRangePopper
                            whiteBackground={true}
                            fromDate={valueDateFrom} handleFromDate={handleValueDateFrom}
                            toDate={valueDateTo} handleToDate={handleValueDateTo}
                            dateName={t('search.valueDate')} mobile={isMobile} />
                    </Stack>
                </Grid>
                <Grid>
                    <Stack direction="column" spacing={theme.spacing(3)}>
                        <Stack direction="row">
                            <TextField
                                size="small"
                                variant="outlined"
                                error={amountError(amountFrom)}
                                value={amountFrom}
                                color={amountError(amountFrom) ? "error" : "primary"}
                                onChange={(e) => { handleAmountFrom(e.target.value) }}
                                InputProps={{ sx: { borderBottomRightRadius: 0, borderTopRightRadius: 0 } }}
                                inputProps={{ style: { textAlign: "right", } }}
                                sx={{
                                    minWidth: "6.5rem", maxWidth: "9rem",
                                    backgroundColor: theme.palette.background.paper,
                                }}
                                InputLabelProps={{ shrink: true, }}
                                id="amountFrom" label={t("search.amountFrom")} />
                            <TextField
                                size="small"
                                variant="outlined"
                                error={amountError(amountTo)}
                                value={amountTo}
                                color={amountError(amountTo) ? "error" : "primary"}
                                onChange={(e) => { handleAmountTo(e.target.value) }}
                                InputProps={{ sx: { borderBottomLeftRadius: 0, borderTopLeftRadius: 0 } }}
                                inputProps={{ style: { textAlign: "right" } }}
                                sx={{
                                    minWidth: "6.5rem", maxWidth: "9rem",
                                    backgroundColor: theme.palette.background.paper,
                                }}
                                InputLabelProps={{ shrink: true, }}
                                id="amountTo" label={t("search.amountTo")} />
                        </Stack>
                        <Stack direction="row">
                            <TextField
                                size="small"
                                variant="outlined"
                                error={amountError(voucherNoFrom)}
                                value={voucherNoFrom}
                                color={amountError(voucherNoFrom) ? "error" : "primary"}
                                onChange={(e) => { handleVoucherNoFrom(e.target.value) }}
                                InputProps={{ sx: { borderBottomRightRadius: 0, borderTopRightRadius: 0 } }}
                                inputProps={{ style: { textAlign: "right", } }}
                                sx={{
                                    minWidth: "6.5rem", maxWidth: "9rem",
                                    backgroundColor: theme.palette.background.paper,
                                }}
                                InputLabelProps={{ shrink: true, }}
                                id="voucherNoFrom" label={t("search.voucherIdFrom")} />
                            <TextField
                                size="small"
                                variant="outlined"
                                error={amountError(voucherNoTo)}
                                value={voucherNoTo}
                                color={amountError(voucherNoTo) ? "error" : "primary"}
                                onChange={(e) => { handleVoucherNoTo(e.target.value) }}
                                InputProps={{ sx: { borderBottomLeftRadius: 0, borderTopLeftRadius: 0 } }}
                                inputProps={{ style: { textAlign: "right" } }}
                                sx={{
                                    minWidth: "6.5rem", maxWidth: "9rem",
                                    backgroundColor: theme.palette.background.paper,
                                }}
                                InputLabelProps={{ shrink: true, }}
                                id="voucherNoTo" label={t("search.voucherIdTo")} />
                        </Stack>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack direction="column" spacing={theme.spacing(3)}>
                        <TextField size="small" variant="outlined" color="warning"
                            sx={{ width: "9rem", backgroundColor: theme.palette.background.paper, }}
                            value={debet}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputComponent: NumericFormatWhole as any,
                                endAdornment:
                                    <InputAdornment position="end" component={IconButton} onClick={() => handleDebet("")}
                                        sx={{ display: debet ? "inherit" : "none" }}><Close /></InputAdornment>,
                            }}
                            onChange={(e) => handleDebet(e.target.value)}
                            id="searchDebet" label={t('search.debet')} />
                        <TextField size="small" variant="outlined" color="warning"
                            sx={{ width: "9rem", backgroundColor: theme.palette.background.paper, }}
                            value={credit}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputComponent: NumericFormatWhole as any,
                                endAdornment:
                                    <InputAdornment position="end" component={IconButton} onClick={() => handleCredit("")}
                                        sx={{ display: credit ? "inherit" : "none" }}><Close /></InputAdornment>,
                            }}
                            onChange={(e) => handleCredit(e.target.value)}
                            id="searchCredit" label={t('search.credit')} />
                    </Stack>
                </Grid>
                <Grid>
                    <Stack direction="column" spacing={theme.spacing(3)}>
                        <TextField size="small" variant="outlined" color="warning"
                            sx={{ width: "12rem", backgroundColor: theme.palette.background.paper, }}
                            value={department}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end" component={IconButton} onClick={() => handleDepartment("")}
                                        sx={{ display: department ? "inherit" : "none" }}><Close /></InputAdornment>,
                            }}
                            onChange={(e) => handleDepartment(e.target.value)}
                            id="searchDepartment" label={t('search.department')} />
                        <TextField size="small" variant="outlined" color="warning"
                            sx={{ width: "12rem", backgroundColor: theme.palette.background.paper, }}
                            value={project}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end" component={IconButton} onClick={() => handleProject("")}
                                        sx={{ display: project ? "inherit" : "none" }}><Close /></InputAdornment>,
                            }}
                            onChange={(e) => handleProject(e.target.value)}
                            id="searchProject" label={t('search.project')} />
                    </Stack>
                </Grid>
                <Grid>
                    <Stack direction="column" spacing={theme.spacing(3)}>
                        
                        <DateRangePopper
                            whiteBackground={true}
                            fromDate={createdDateFrom} handleFromDate={handleCreatedDateFrom}
                            toDate={createdDateTo} handleToDate={handleCreatedDateTo}
                            dateName={t('search.created')} mobile={isMobile} />
                    </Stack>
                </Grid>
                <Grid>
                    <Stack direction="column" spacing={theme.spacing(3)}>
                        <TextField size="small" variant="outlined" color="warning"
                            sx={{ width: "12rem", backgroundColor: theme.palette.background.paper, }}
                            value={comment}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end" component={IconButton} onClick={() => handleComment("")}
                                        sx={{ display: comment ? "inherit" : "none" }}><Close /></InputAdornment>,
                            }}
                            onChange={(e) => handleProject(e.target.value)}
                            id="searchComment" label={t('search.comment')} />
                    </Stack>
                </Grid>
            </Grid>
        </Collapse>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </Box>

}
export default DatagridVoucherRegistrationToolbar;